import { FetchJson } from './Fetch';
import { FetchJson as Fetch } from './client_Fetch';
const commonAPI = {
    getProgress:(classId) => FetchJson.get( `/admin-class/${classId}/in-progress`),
    getMyInfo:() => FetchJson.get( `/auth`),
    userLogout:() => FetchJson.get( `/auth/logout`),
    getCategory:(data:object) => FetchJson.get("/common/category", data),
    getJobList:(data:object) => FetchJson.get(`/common/job-list`, data),
    getDegreeList:(data:object) => FetchJson.get(`/common/degree-list`, data),
    postCategory:(data:object) => FetchJson.post(`/common/category`, data),
    postVideoMetadata:(data:object) => FetchJson.post(`/jw-player/token`, data),
    patchVideoMetadata:(jwPlayerId:string, data:object) => FetchJson.patch(`/jw-player/token/${jwPlayerId}`, data),
    postSignInData:(data) => FetchJson.post(`/auth/signin`,data),
    getJwpToken:(id:any) => FetchJson.get( `/jw-player/drm/${id}/jwt`),
    getLearningObj:() => FetchJson.get(`/common/learning-objectives`),
    getJwpMedia:(id:any) => FetchJson.get( `/jw-player/media/${id}`),
}

export { commonAPI };